// Make the admin page a private route
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from '../hooks/useAdminAuth.js'

const AdminRoute = ({ children }) => {

    
    const [isVerified, setIsVerified] = useState(null); // null to indicate loading
    const { verify } = useAdminAuth()
    useEffect(() => {
        /*
        const verify = async () => {
            try {
                const response = await fetch('https://entssc.cas.mcmaster.ca/api/auth/verify', {
                    method: 'GET',
                    credentials: 'include' // Required to send cookies
                });

                setIsVerified(response.ok); // Set authentication status
            } catch (error) {
                console.error("Verification error:", error);
                setIsVerified(false);
            }
        };
        */
        const checkAuth = async () => {
            const verified = await verify();
            setIsVerified(verified);
        };

        checkAuth();
    }, []);

    if (isVerified === null) {
        return <p>Loading...</p>; // Show loading until verification is done
    }

    return isVerified ? children : <Navigate to="/admin-login" />;
}

export default AdminRoute

// import { Navigate } from "react-router-dom";
// import { useAdminAuth } from '../hooks/useAdminAuth.js'

// const AdminRoute = ({ children }) => {
//     // Get necessary data from the useAuth hook
//     const { isAuth, loading } = useAdminAuth()

//     // Placeholder (maybe make it fancier in the future)
//     if (loading) return <p>Loading...</p>

//     return isAuth ? children : <Navigate to="/admin-login"/>
// }

// export default AdminRoute